module.exports = __webpack_public_path__ + "static/img/shop8.ba66f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop8.png
// module id = cGAX
// module chunks = 2